import classNames from 'classnames'
import React from 'react'

import * as styles from './styles.less'

export default function Column({children, className}) {
  return <div className={classNames(styles.column, className)}>{children}</div>
}
